/* eslint-disable */
import { showToast as globalToast } from "../Toast";

// ── Export helpers ────────────────────────────────────────────────────────────
export function exportExcel(items, fields) {
  const cols = ["#", ...fields.map(f => f.label)];
  const rows = items.map((item, idx) => [idx + 1, ...fields.map(f => item[f.key] || "")]);
  const csv  = [cols, ...rows].map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(",")).join("\r\n");
  const blob = new Blob(["\uFEFF" + csv], { type:"text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `carolina_lemke_catalog_${new Date().toISOString().slice(0,10)}.csv`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

export function exportPDF(items, fields) {
  const date = new Date().toLocaleDateString("en-GB", { day:"2-digit", month:"long", year:"numeric" });
  const headerCells = ["#", ...fields.map(f => `<th>${f.label}</th>`)].join("");
  const bodyRows = items.map((item, idx) => {
    const cells = fields.map(f => `<td>${item[f.key] || "—"}</td>`).join("");
    return `<tr><td style="color:#999;text-align:center">${idx+1}</td>${cells}</tr>`;
  }).join("");
  const html = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Carolina Lemke Berlin — Originals</title>
<style>* { margin:0; padding:0; box-sizing:border-box; } body { font-family:'Helvetica Neue',Arial,sans-serif; color:#0a0a0a; background:#fff; padding:28px 32px; }
.header { border-bottom:2px solid #0a0a0a; padding-bottom:14px; margin-bottom:18px; display:flex; justify-content:space-between; align-items:flex-end; }
.brand { font-size:11px; font-weight:800; letter-spacing:0.28em; text-transform:uppercase; } .sub { font-size:8px; letter-spacing:0.22em; color:#888; text-transform:uppercase; }
.meta { font-size:10px; color:#888; text-align:right; } table { width:100%; border-collapse:collapse; font-size:9px; }
thead tr { background:#0a0a0a; } thead th { color:#fff; padding:6px 8px; text-align:left; font-weight:700; letter-spacing:0.06em; text-transform:uppercase; white-space:nowrap; }
tbody tr:nth-child(even) td { background:#f7f7f5; } tbody td { padding:5px 8px; border-bottom:1px solid #e8e8e4; vertical-align:top; max-width:120px; }
.footer { margin-top:16px; font-size:8px; color:#bbb; text-align:center; letter-spacing:0.1em; text-transform:uppercase; }
@media print { body { padding:12px 16px; } @page { margin:10mm 8mm; size:A4 landscape; } }</style></head><body>
<div class="header"><div><div class="brand">CAROLINA LEMKE</div><div class="sub">BERLIN · ORIGINAL ITEMS CATALOG</div></div>
<div class="meta"><div><strong>${items.length}</strong> items exported</div><div>${date}</div></div></div>
<table><thead><tr>${headerCells}</tr></thead><tbody>${bodyRows}</tbody></table>
<div class="footer">Carolina Lemke Berlin — Confidential</div>
<script>window.onload=function(){window.print();}<\/script></body></html>`;
  const win = window.open("", "_blank");
  if (!win) { globalToast("Please allow popups to export PDF", "warning"); return; }
  win.document.write(html); win.document.close();
}

export function exportJSON(items) {
  const payload = { exportedAt:new Date().toISOString(), source:"Carolina Lemke Berlin", count:items.length, items };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type:"application/json" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `carolina_lemke_catalog_${new Date().toISOString().slice(0,10)}.json`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

export function parseImportCSV(text, fields) {
  const lines = text.trim().split(/\r?\n/);
  if (lines.length < 2) return [];
  const header = lines[0].replace(/^\uFEFF/, "").split(",").map(h => h.replace(/^"|"$/g,"").trim());
  const fieldMap = {};
  fields.forEach(f => {
    const idx = header.findIndex(h => h.toLowerCase() === f.label.toLowerCase());
    if (idx >= 0) fieldMap[f.key] = idx;
  });
  const imported = [];
  for (let i = 1; i < lines.length; i++) {
    if (!lines[i].trim()) continue;
    const vals = []; let cur = "", inQ = false;
    for (const ch of lines[i]) {
      if (ch === '"') inQ = !inQ;
      else if (ch === ',' && !inQ) { vals.push(cur); cur = ""; }
      else cur += ch;
    }
    vals.push(cur);
    const item = { id:Date.now() + i, images:[] };
    Object.entries(fieldMap).forEach(([key, idx]) => { if (vals[idx] !== undefined) item[key] = vals[idx].replace(/^"|"$/g,"").trim(); });
    if (item.model || item.sku) imported.push(item);
  }
  return imported;
}

export function buildCSV(rows) {
  if (!rows.length) return '';
  const headers = Object.keys(rows[0]);
  const bom = '\uFEFF';
  const lines = [headers.join(','), ...rows.map(r => headers.map(h => JSON.stringify(r[h] ?? '')).join(','))];
  return bom + lines.join('\n');
}

export function printLabels(itemsToPrint) {
  if (!itemsToPrint.length) return;
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/>
<title>Labels — Carolina Lemke Berlin</title>
<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"><\/script>
<style>* { box-sizing:border-box; margin:0; padding:0; } body { font-family:'Helvetica Neue',Arial,sans-serif; background:#fff; }
.grid { display:grid; grid-template-columns:repeat(3,1fr); gap:10px; padding:16px; }
.label { border:1px solid #e2e8f0; border-radius:6px; padding:12px 10px 8px; display:flex; flex-direction:column; align-items:center; gap:5px; break-inside:avoid; }
.brand { font-size:9px; font-weight:800; letter-spacing:0.15em; text-transform:uppercase; color:#0a0a0a; text-align:center; }
.model { font-size:11px; font-weight:600; color:#334155; text-align:center; }
.sku { font-size:8px; color:#94a3b8; letter-spacing:0.05em; } svg { max-width:100%; }
@media print { body { margin:0; } .grid { gap:6px; padding:8px; } .no-print { display:none; } }</style></head><body>
<div class="no-print" style="padding:14px 20px;background:#0a0a0a;color:#fff;display:flex;justify-content:space-between;align-items:center;">
<span style="font-weight:700;font-size:13px;letter-spacing:0.1em;">CAROLINA LEMKE BERLIN — ${itemsToPrint.length} LABELS</span>
<button onclick="window.print()" style="background:#fff;color:#0a0a0a;border:none;padding:8px 20px;border-radius:4px;font-weight:700;cursor:pointer;font-size:12px;">🖨️ Print</button></div>
<div class="grid">${itemsToPrint.map(item => {
  const code = item.sku || item.id || "CLB-000";
  return `<div class="label"><div class="brand">${item.brand || "Carolina Lemke"}</div>
${item.model ? `<div class="model">${item.model}</div>` : ""}
<svg class="barcode" data-code="${code}"></svg><div class="sku">${code}</div></div>`;
}).join("")}</div>
<script>document.querySelectorAll('.barcode').forEach(el => { try { JsBarcode(el, el.dataset.code, {format:"CODE128",width:1.5,height:40,displayValue:false,margin:4,lineColor:"#0a0a0a",background:"transparent"}); } catch(e) {} });<\/script></body></html>`;
  const win = window.open("", "_blank");
  if (!win) { globalToast("Please allow popups", "warning"); return; }
  win.document.write(html); win.document.close();
}
